export const COMMANDS = {
    pin: {
        COMMAND: 'pin',
    },
    PIN_PARTICIPANT: {
        COMMAND: 'pin_participant',
    },
    UN_PIN_PARTICIPANT: {
        COMMAND: 'un_pin_participant',
    },
    STAGE_VIEW: {
        COMMAND: 'stage_view',
        FILM_STRIP_ON: 'on',
        FILM_STRIP_OFF: 'off',
    },
    GRID_VIEW: {
        COMMAND: 'grid-view',
        FOUR: '4',
        NINE: '9',
        SIXTEEN: '16',
        FIFTY: '25'
    },
    MIC: {
        COMMAND: 'micro',
        ON: 'on',
        OFF: 'off'
    },
    CAM: {
        COMMAND: 'camera',
        ON: 'on',
        OFF: 'off'
    },
    MIC_SIP: {
        COMMAND: 'micro-sip',
        ON: 'on',
        OFF: 'off'
    },
    CAM_SIP: {
        COMMAND: 'camera-sip',
        ON: 'on',
        OFF: 'off'
    },
    LOCK: {
        COMMAND: "lock",
        ON: "on",
        OFF: "off"
    },
    SHARE_SCREEN: {
        COMMAND: "share-screen",
        ON: "on",
        OFF: "off"
    },
    SIP: {
        COMMAND: "sip"
    },
    ROOM: {
        COMMAND: "end"
    },
    SET_PASSWORD: {
        COMMAND: 'set-password'
    },
    CHANGE_NAME: {
        COMMAND: 'change-name'
    },
    MUTE_MEDIA_BY_TYPE: {
        COMMAND: 'mute-media-by-type'
    },
    CHANGE_LAYOUT: {
        COMMAND: 'change-layout',
    },
    AUDIO_MODERATION: {
        COMMAND: 'audio-moderation',
        ENABLE: 'enable',
        DISABLE: 'disable'
    },
    VIDEO_MODERATION: {
        COMMAND: 'video-moderation',
        ENABLE: 'enable',
        DISABLE: 'disable'
    },
    APPROVE_AUDIO_PARTICIPANT: {
        COMMANDS: 'approved-audio-participant'
    },
    LOCAL_AUDIO_PARTICIPANT_APPROVED: {
        COMMANDS: 'local-audio-participant-approved'
    },
    APPROVE_VIDEO_PARTICIPANT: {
        COMMANDS: 'approved-video-participant'
    },
    LOCAL_VIDEO_PARTICIPANT_APPROVED: {
        COMMANDS: 'local-video-participant-approved'
    },
    REJECT_AUDIO_PARTICIPANT: {
        COMMANDS: 'rejected-audio-participant'
    },
    LOCAL_AUDIO_CASCADE_REJECTED: {
        COMMANDS: 'rejected-audio-cascade'
    },
    LOCAL_AUDIO_PARTICIPANT_REJECTED: {
        COMMANDS: 'local-audio-participant-rejected'
    },
    REJECT_VIDEO_PARTICIPANT: {
        COMMANDS: 'rejected-video-participant'
    },
    LOCAL_VIDEO_CASCADE_REJECTED: {
        COMMANDS: 'rejected-video-cascade'
    },
    LOCAL_VIDEO_PARTICIPANT_REJECTED: {
        COMMANDS: 'local-video-participant-rejected'
    },
    KICK_REMOTE_PARTICIPANT: {
        COMMAND: 'kick-remote-participant'
    },
    MUTE_PARTICIPANT: {
        COMMAND: 'mute-participant'
    },
    MUTE_VIDEO_PARTICIPANT: {
        COMMAND: 'mute-video-participant'
    },
    HANDLE_CHANGE_START_AUDIO_MUTED: {
        COMMANDS: 'handle-change-start-audio-muted'
    },
    HANDLE_CHANGE_START_VIDEO_MUTED: {
        COMMANDS: 'handle-change-start-video-muted'
    },
    HANDLE_CHANGE_START_REACTIONS_MUTED: {
        COMMANDS: 'handle-change-start-reactions-muted'
    },
    CHANGE_VIEW: {
        COMMANDS: 'change-view-participant',
        MAIN_SPEAKER: 'main-speaker-view',
        FOCUS: 'focus-view',
        TILE: 'tile-view'
    },
    CHANGE_CELLS_DISPLAY: {
        COMMANDS: 'change-cells-display'
    },
    RECORDING: {
        START_RECORDING: 'start-recording'
    },
    POLL: {
        ANSWER_POLL: 'answer-poll'
    },
    WHITEBOARD: {
        OPEN_WHITEBOARD: 'open-whiteboard',
        CLOSE_WHITEBOARD: 'close-whiteboard'
    },
    ROOM_CASCADE: {
        COMMAND: 'room-cascade',
        START: 'start',
        STOP: 'stop'
    },
    TURN_ON_MICRO_CASCADE: {
        COMMANDS: 'turn_on_micro_cascade'
    },
    TURN_ON_CAMERA_CASCADE: {
        COMMANDS: 'turn_on_camera_cascade'
    },
    LOCAL_AUDIO_CASCADE_APPROVED: {
        COMMANDS: 'local_audio_cascade_approved'
    },
    LOCAL_VIDEO_CASCADE_APPROVED: {
        COMMANDS: 'local_video_cascade_approved'
    },
    SORT_PARTICIPANTS: {
        COMMANDS: 'sort_participants'
    },
    LOCAL_AUDIO_PAR_APPROVED: {
        COMMANDS: 'local_audio_par_approved'
    },
    LOCAL_VIDEO_PAR_APPROVED: {
        COMMANDS: 'local_video_par_approved'
    },
};
